module.exports = __webpack_public_path__ + "img/IMG_2519-2.7659463f.jpg";